// extracted by mini-css-extract-plugin
export var content = "_br-3";
export var list = "_br-4";
export var settingsContent = "_br-7";
export var settingsPanel = "_br-8";
export var state = "_br-6";
export var triggerBadge = "_br-2";
export var triggerButton = "_br-1";
export var triggerShell = "_br-0";
export var unreadDot = "_br-5";